import Configuration from 'components/images/searchcustomization-snapshot.jpg';
import Filters from 'components/images/filters.png';
import * as React from 'react';
export default {
  Configuration,
  Filters,
  React
};